import isNull from 'lodash/isNull'
import * as Moment from 'moment'
import { Observable } from 'rxjs/Observable'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as Elasticsearch from '../../elasticsearch'
import * as Constants from './constants'
import * as Types from './types'

export const validDateRange = (form: Form.State<Types.DateRangeFormFields>): boolean => {
// Only process requests with valid date ranges - skip custom without an end date
  return form.fields.dateRange !== Constants.CUSTOM_DATE_RANGE || !isNull(form.fields.endDate)
}

const formattedDate = (date: Moment.Moment, formatString?: string): string =>
  Moment.isMoment(date) ? date.utc().format(formatString) : null

export const searchUtcDateRange = (form: Form.State<Types.DateRangeFormFields>): any => {
  return (form.fields.dateRange !== Constants.CUSTOM_DATE_RANGE)
  ?
    {
      gte: form.fields.dateRange.split('|')[0],
      lt: form.fields.dateRange.split('|')[1],
    }
  :
    {
      gte: formattedDate(form.fields.startDate),
      lt: formattedDate(Moment(form.fields.endDate).add(1, 'day')),
    }
}

export const searchDateRange = (form: Form.State<Types.DateRangeFormFields>): any => {
  return (form.fields.dateRange !== Constants.CUSTOM_DATE_RANGE)
  ?
    {
      gte: form.fields.dateRange.split('|')[0],
      lt: form.fields.dateRange.split('|')[1],
    }
  :
    {
      gte: formattedDate(Moment(form.fields.startDate), 'YYYY-MM-DD'),
      lt: formattedDate(Moment(form.fields.endDate).add(1, 'day'), 'YYYY-MM-DD'),
    }
}

export const searchStartDate = (form: Form.State<Types.DateRangeFormFields>): string => {
  if (form.fields.dateRange === Constants.CUSTOM_DATE_RANGE) {
    return formattedDate(form.fields.startDate, 'YYYY-MM-DD')
  } else {
    return formattedDate(Elasticsearch.asMoment(form.fields.dateRange.split('|')[0]), 'YYYY-MM-DD')
  }
}

export const searchEndDate = (form: Form.State<Types.DateRangeFormFields>): string => {
  if (form.fields.dateRange === Constants.CUSTOM_DATE_RANGE) {
    return formattedDate(form.fields.endDate, 'YYYY-MM-DD')
  } else {
    return formattedDate(Elasticsearch.asMoment(form.fields.dateRange.split('|')[1]), 'YYYY-MM-DD')
  }
}

export const firstBucketEntry = (parentBucket: any, key: any): any => {
  if (parentBucket && parentBucket.buckets) {
    const children = parentBucket.buckets.filter((b: any) => b.key === key)
    return children ? children[0] : null
  }
  return null
}

const strictUriEncode = (url: string): string => {
  return encodeURIComponent(url).replace(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`)
}

export function urlShorten(shortenUrl: string, share: Types.SocialMediaShare) {
    if (shortenUrl) {
      Observable.ajax({
        body: {
          metadata: {
            email: share.user.email,
          },
          source: share.type,
          url: share.url,
        },
        crossDomain: false,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        responseType: 'json',
        url: shortenUrl,
      }).subscribe((ajaxResponse: any) => {
        openShareWindow(ajaxResponse.response.short_url, share)
      })
    } else {
      openShareWindow(share.url, share)
    }
}

const openShareWindow = (targetUrl: any, share: Types.SocialMediaShare): void => {
  const url = windowUrl(targetUrl, share)
  if ( url ) {
    window.open(url, 'mywin', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0')
  }
}

const windowUrl = (targetUrl: any, share: Types.SocialMediaShare): string => {
  switch (share.type) {
    case Constants.SocialMediaTypes.Twitter:
      // tslint:disable-next-line
      return `https://twitter.com/intent/tweet?url=${targetUrl}&text=${strictUriEncode(share.text)}&via=rasa_io`
    case Constants.SocialMediaTypes.LinkedIn:
      // tslint:disable-next-line
      return `https://www.linkedin.com/shareArticle?url=${targetUrl}&title=${strictUriEncode(share.text)}&source=rasa.io`
    default:
      return null
  }
}

export const twitterShare: Types.ShareGenerator =
  (url: string, text: string, user: any): Types.SocialMediaShare => {
  return {
    text,
    title: 'Twitter',
    type: Constants.SocialMediaTypes.Twitter,
    url,
    user,
  }
}

export const linkedInShare: Types.ShareGenerator =
  (url: string, text: string, user: any): Types.SocialMediaShare => {
  return {
    text,
    title: 'LinkedIn',
    type: Constants.SocialMediaTypes.LinkedIn,
    url,
    user,
  }
}

export const TWITTER: Types.SocialMediaMaker = {
  generator: twitterShare,
  type: Constants.SocialMediaTypes.Twitter,
}
export const LINKED_IN: Types.SocialMediaMaker = {
  generator: linkedInShare,
  type: Constants.SocialMediaTypes.LinkedIn,
}

export const ALL_SOCIAL_MEDIAS: Types.SocialMediaMaker[] = [TWITTER, LINKED_IN]

export const reportStateFromUrl = (state: any, key: string): any => {
  return {
    ...state,
    reports: {
      ...state.reports,
      [key]: {
        ...state.reports[key],
        form: {
          ...state.reports[key].form,
          fields: {
            ...state.reports[key].form.fields,
            ...App.filterObject(state.app.urlParams, state.reports[key].form.fields),
          },
        },
      },
    },
  }
}

export const getDisplayedClickType = (key: string): string => {
  switch (key) {
    case Constants.ONLY_SUSPECT_CLICKS_KEY: return 'suspectClick'
    case Constants.REAL_CLICKS_KEY: return 'realClick'
    default: return 'totalClick'
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/utils.ts